import { useContext, useEffect, useState } from "react"
import { FormLabel, InlineLoading } from "carbon-components-react"
import "./SpeakerBio.scss"
import { deleteChannelSources, getChannelSources, sortChannelSources } from "api/functions/functions"
import TileWrapper, { TileButton, TileDeleteButton } from "ui/TileWrapper/TileWrapper"
import Button from "ui/Button"
import MainContext from "context/MainContext"
import ChannelSourceForm from "forms/ChannelSourceForm/ChannelSourceForm"
import { useParams } from "react-router-dom"
import { Edit16, Renew16 } from "@carbon/icons-react"
import GeneralDeleteModal from "ui/GeneralDeleteModal/GeneralDeleteModal"
import EmptyAlert from "ui/EmptyAlert/EmptyAlert"

const ChannelSources = (props) => {

    const { event } = useParams()
    const context = useContext(MainContext)
    const [value, setValue] = useState([])
    const [data, setData] = useState([])
    const [mode, setMode] = useState("bio")
    const [loading, setLoading] = useState(false)
    const [loaded, setLoaded] = useState(false)
    const [selected, setSelected] = useState()
    const [deleteRoomModalOpen, setDeleteRoomModalOpen] = useState(false)
    // const [deleteRoomModalOpen, setDeleteRoomModalOpen] = useState(false)

    useEffect(() => {
        loadData()
    }, [])

    useEffect(() => {
        setValue(data)
        if (data?.length) {
            props.setDefault(data[0].url, props.eventType)
        }
    }, [data])

    const loadData = async () => {
        setLoading(true)
        let queryParams = {
            event_type: props.eventType
        }
        const channelId = props.channelId
        const res = await getChannelSources({
            event,
            channelId
        }, queryParams)

        setData(res?.data)

        props.onChange(res?.data.map(item => item.id))
        setLoading(false)
        setLoaded(true)
    }

    const openBio = () => {
        setMode("bio")
        loadData()
    }

    const openAddNew = () => {
        setSelected()
        setMode("new")
    }

    const editItem = (selectedItemData) => {
        setSelected(selectedItemData)
        setMode("edit")
    }

    const onItemChanged = (newValue) => {
        setValue(newValue)
    }

    const goUp = (position) => {
        move(position, position - 1)
    }
    const goDown = (position) => {
        move(position, position + 1)
    }

    const move = async (position, newPosition) => {
        let newCollection = [...value]
        let newData = [...data]
        const removed = newCollection.splice(position, 1)
        newCollection.splice(newPosition, 0, removed[0])
        setValue(newCollection)

        const removedData = newData.splice(position, 1)
        newData.splice(newPosition, 0, removedData[0])
        setData(newData)

        const positions = newData.map(item => item.id)

        const res = await sortChannelSources(
            {
                event,
                channelId: props.channelId
            }, {
            positions: positions
        })
        setValue(res.data)
    }

    const onRequestDeleteClicked = (selectedItemData) => {
        setSelected(selectedItemData)
        setDeleteRoomModalOpen(true)
    }

    const onDeleteModalRequestClose = () => {
        setSelected()
        setDeleteRoomModalOpen(false)
    }

    const onDelete = async () => {
        const res = await deleteChannelSources({
            event,
            channelId: props.channelId,
            channelSourceId: selected.id
        })
        setSelected()
        loadData()
        return res
    }

    let content = null

    switch (mode) {
        case "bio":
            content = (
                <>
                    <Button
                        size="field"
                        onClick={() => openAddNew()}>
                        Add New
                    </Button>
                    <Button
                        hasIconOnly
                        renderIcon={Renew16}
                        iconDescription="Relaod"
                        size="field"
                        kind="secondary"
                        disabled={loading}
                        onClick={() => loadData()}
                    />
                    {
                        loading ? (
                            <div style={{ padding: "1rem", backgroundColor: "#eeeeee" }}>
                                <InlineLoading />
                            </div>
                        ) : data?.length ?
                            data.map((item, index) => {
                                return (
                                    <TileWrapper
                                        titleComponent={"div"}
                                        key={`main-list-item-${item.id}-${index}`}
                                        title={`${item.title_default} (#${item.id})`}
                                        // onTitleClicked={props.onClick}
                                        enableGoUp={index > 0}
                                        disableTitlePadding={true}
                                        enableGoDown={index < data.length - 1}
                                        goUp={() => goUp(index)}
                                        goDown={() => goDown(index)}
                                        footer={(
                                            <>
                                                <TileButton
                                                    iconDescription="Edit item"
                                                    renderIcon={Edit16}
                                                    onClick={() => editItem(item)}
                                                />
                                                <TileDeleteButton
                                                    onClick={() => onRequestDeleteClicked(item)}
                                                />
                                            </>

                                        )}
                                    >
                                        <small className="small">
                                            {item.url}
                                        </small>
                                    </TileWrapper>
                                )
                            }) : (
                                <EmptyAlert />
                            )
                    }
                </>
            )
            break
        // case "table":
        //     content = <ChannelSourcesTable
        //         value={value}
        //         speakers={data}
        //         // data={data}
        //         onOpenAddNew={() => openAddNew()}
        //         onChange={onItemChanged}
        //         onClose={openBio}
        //         channelId={props.channelId}
        //     // onLoadSpeakers={loadSpeakers}
        //     />
        //     break
        case "new":
        case "edit":
            content = (
                <div style={{
                    padding: "1rem",
                    margin: "0",
                    border: "1px solid #dddddd"
                }}
                >
                    <ChannelSourceForm
                        onItemChanged={(data) => {
                            if (data.id) {
                                onItemChanged(value.concat(data.id))
                            }
                            // openTable()
                        }}
                        defaultValues={selected}
                        onAbortClicked={openBio}
                        channelId={props.channelId}
                        eventType={props.eventType}
                    />
                </div>
            )
            break
        default:
            content = null
    }

    return (
        <div className="speaker-bio">
            {
                props.labelText ? (
                    <div>
                        <FormLabel>
                            {props.labelText}
                        </FormLabel>
                    </div>
                ) : null
            }
            {content}
            <GeneralDeleteModal
                deleting={false}
                open={deleteRoomModalOpen}
                onDelete={onDelete}
                onRequestClose={onDeleteModalRequestClose}
            />
        </div>

    )
}

export default ChannelSources